var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21649_141659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.74902 4.58008H2.75203",
    stroke: "white",
    strokeWidth: 0.458176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.458008 2.01957C1.08803 1.45606 1.90363 1.14453 2.74889 1.14453C3.59414 1.14453 4.40975 1.45606 5.03977 2.01957",
    stroke: "white",
    strokeWidth: 0.458176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.14551 2.94393C1.57374 2.52418 2.14948 2.28906 2.74912 2.28906C3.34877 2.28906 3.92451 2.52418 4.35274 2.94393",
    stroke: "white",
    strokeWidth: 0.458176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94727 3.76298C2.16138 3.5531 2.44925 3.43555 2.74907 3.43555C3.0489 3.43555 3.33677 3.5531 3.55088 3.76298",
    stroke: "white",
    strokeWidth: 0.458176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21649_141659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.49811,
    height: 5.49811,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.429e2d2db6a06ab41b52a91ea0954fff.svg";
export { ForwardRef as ReactComponent };